import React, { useState, useEffect } from 'react';
import styles from './Feedback.module.css';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaGoogle } from "react-icons/fa";
import { FaStar } from 'react-icons/fa'
import { db } from '../../../firebase-config';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';

function Feedback() {
    const [feedback, setFeedback] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Default reviews - these will ALWAYS be shown
    const defaultReviews = [
        {
            userImg: "https://lh3.googleusercontent.com/a-/ALV-UjVQYEN5Vw2K0VZeOI_6681J382tBkI40zQSuYZYpZ2FoyW3CQsy=w120-h120-p-rp-mo-br100",
            userName: "Priyanka Dey",
            userReview: "At present I am taking training under Affiliate Ritual institution. Now my one months training is completed and 2 more months left. I m very satisfied to take training under Supriyo sir. He is very helpful and kind person. All the members of center is Same as Supriyo sir. Very much understanding and helpful. I can grow myself under his training. Thank you sir for supporting us.",
            userRating: 5,
            order: 1
        },
        {
            userImg: "https://lh3.googleusercontent.com/a-/ALV-UjUxX5qv1IR6hLjuCBmYUQKxe1VlMCup9XPv2mzOOrnNU5CmAo8=w120-h120-p-rp-mo-br100",
            userName: "Spandan Saha",
            userReview: "Hello my name is Spandan Saha. I am a student of Affiliate Ritual for past 1.5 months to learn about Digital Marketing, Social Media Management, Content Creation and how to survive in the online world as a Freelancer. The course is excellent and I am thoroughly enjoying the course . Digital Coach Supriyo Sir is an great Coach who keeps his students and their problems his top priority and fills their life with positivity. All the courses of Affiliate Ritual are must recommend for those who want to get out of the 9-5 circle and make their name in the online world.",
            userRating: 4,
            order: 2
        },
        {
            userImg: "https://lh3.googleusercontent.com/a-/ALV-UjXYccgR8ng9yDyHwJcnEfkWrzE5tit2kPb_utrb1zbrVF-bAHFB=w120-h120-p-rp-mo-ba2-br100",
            userName: "Sangita Bishnu",
            userReview: "I've been learning freelancing from Supriyo sir and it's been an amazing experience.. The tips and tricks, and his guidance have boosted my confidence. If you aspire to become a freelancer, I wholeheartedly recommend joining Affiliate Ritual.",
            userRating: 5,
            order: 3
        },
        {
            userImg: "https://lh3.googleusercontent.com/a-/ALV-UjWOQfSY2VkfKpDlSKJ6iwYA_D2fsIMZnUYvKPuwq9rpa9ekJiFA=w120-h120-p-rp-mo-br100",
            userName: "Chayan Roy",
            userReview: "#Digitalcoach Supriyo Sir is too much helpful & supportive..😊😎.As a freelancer I am feeling great to learn form Affiliate Ritual. On this upcoming day every IT related student's should learn from this institute & basically Digital Marketing on AI based tool.",
            userRating: 5,
            order: 4
        },
        {
            userImg: "https://lh3.googleusercontent.com/a-/ALV-UjVEte_t10GxVqht1BVqJCAnKvCAhVYTcyY8oVnjE8QNP1uRn7yx=w120-h120-p-rp-mo-br100",
            userName: "Shibam Biswas",
            userReview: "Hi! My name is Shibam Biswas. I'm currently learning Digital Marketing course from Affiliate Ritual. I am happy to say that my overall experience in Affiliate Ritual is very good till now. I am eager to learn most of the things of Digital Marketing. Thanks Supriyo sir for guiding me through this journey. No doubt this is the best digital marketing institute in Kolkata.",
            userRating: 4,
            order: 5
        }
    ];

    // Fetch reviews from Firebase
    useEffect(() => {
        const fetchReviews = async () => {
            try {
                setLoading(true);
                setError(null);
                
                const reviewsCollection = collection(db, 'googleReviews');
                const q = query(reviewsCollection, orderBy('order', 'asc'));
                const querySnapshot = await getDocs(q);
                
                const firebaseReviews = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                
                // Use Firebase data if available, otherwise fall back to default reviews
                setFeedback(firebaseReviews.length > 0 ? firebaseReviews : defaultReviews);
                
            } catch (error) {
                setError(error.message);
                // Use default reviews if Firebase fails
                setFeedback(defaultReviews);
            } finally {
                setLoading(false);
            }
        };

        fetchReviews();
    }, []);

    const CustomPrevArrow = (props) => {
        const { onClick } = props;
        return <div className={`${styles.customArrow} ${styles.prev}`} onClick={onClick} />;
    };

    const CustomNextArrow = (props) => {
        const { onClick } = props;
        return <div className={`${styles.customArrow} ${styles.next}`} onClick={onClick} />;
    };

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        arrows: true,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };

    if (loading) {
        return (
            <div className={styles.feedbackMain}>
                <div className={styles.rating}>
                    <span className={styles.score}>5.0</span>
                    <div className={styles.stars}>
                        <FaStar className={styles.starFilled} />
                        <FaStar className={styles.starFilled} />
                        <FaStar className={styles.starFilled} />
                        <FaStar className={styles.starFilled} />
                        <FaStar className={styles.starFilled} />
                    </div>
                    <span className={styles.reviews}>(115,521)</span>
                </div>
                <div style={{ textAlign: 'center', padding: '2rem', color: 'white' }}>
                    Loading reviews...
                </div>
            </div>
        );
    }

    if (error) {
        // Use default reviews on error
        setFeedback(defaultReviews);
    }

    return (
        <div className={styles.feedbackMain}>
            <div className={styles.rating}>
                <span className={styles.score}>5.0</span>
                <div className={styles.stars}>
                    <FaStar className={styles.starFilled} />
                    <FaStar className={styles.starFilled} />
                    <FaStar className={styles.starFilled} />
                    <FaStar className={styles.starFilled} />
                    <FaStar className={styles.starFilled} />
                    {/* <FaStarHalf className={styles.starFilled} /> */}
                </div>
                <span className={styles.reviews}>(115,521)</span>
            </div>

            <div>
                {feedback.length > 0 ? (
                    <Slider {...settings}>
                        {feedback.map((item, i) => (
                            <div key={item.id || i} className={styles.feedbackItem}>
                                                                <div className={styles.feedbackItpWrapper}>
                                    <div style={{ position: 'relative' }}>
                                        <img
                                            className={styles.feedbackIcon}
                                            src={item.userImg}
                                            alt={item.userName}
                                            loading="lazy"
                                            onError={(e) => {
                                                e.target.style.display = 'none';
                                                e.target.nextSibling.style.display = 'flex';
                                            }}
                                        />
                                        <div 
                                            className={styles.feedbackIcon}
                                            style={{
                                                display: 'none',
                                                background: 'linear-gradient(91.94deg, #b17e32 -8.77%, #f3e681 58.63%, #cf9f41 107.45%)',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                color: 'white',
                                                fontSize: '1.5rem',
                                                fontWeight: 'bold',
                                                position: 'absolute',
                                                top: '0',
                                                left: '0'
                                            }}
                                        >
                                            {item.userName.charAt(0).toUpperCase()}
                                        </div>
                                    </div>
                                    <div className={styles.feedbackTpWrapper}>
                                        {/* google user name */}
                                        <div className={styles.feedbackTitle}>{item.userName}</div>

                                        {/* google ratings - star */}
                                        <div className={styles.stars}>
                                            {Array.from({ length: 5 }, (_, index) => (
                                                <FaStar
                                                    key={index}
                                                    className={index < item.userRating ? styles.starFilled : styles.starEmpty}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                    <FaGoogle className={styles.feedbackQuoteRight} />
                                </div>
                                <div className={styles.feedbackDescription}>{item.userReview}</div>
                            </div>
                        ))}
                    </Slider>
                ) : (
                    <div style={{ textAlign: 'center', padding: '2rem', color: 'white' }}>
                        No reviews available
                    </div>
                )}
            </div>
        </div>
    );
}

export default Feedback;
